import { memo } from 'react';
import { Box, Icon, Image } from '@bonanza-social/moonlight';
import { StatusGemWithOutlineProps } from './StatusGemWithOutline.types';
import { StatusType } from '../../state';

function StatusGemWithOutline({
  playerStatus,
  size,
  outlineColor,
  isLocked = false,
}: StatusGemWithOutlineProps) {
  const statusName: StatusType =
    playerStatus === 'Member' ? 'Amethyst' : playerStatus;

  return (
    <Box position="relative">
      <Icon
        name={`${statusName}GemOutline`}
        width={size}
        height={size}
        color={outlineColor}
      />
      <Image
        name={
          isLocked ? `status.${statusName}GemLocked` : `status.${statusName}Gem`
        }
        position="absolute"
        width={size}
        height={size}
        transform={`scale(0.77)`}
      />
    </Box>
  );
}

export default memo(StatusGemWithOutline);
